export const BOARDING_MODES = [
    { value: "DayOnly", label: "Day scholar only", hint: "No boarding facilities" },
    { value: "BoardingOnly", label: "Boarding only", hint: "All students are boarders" },
    { value: "Both", label: "Day & boarding", hint: "Students can be day or boarders" },
];

export function normalizeBoardingMode(value, hasBoardingFallback) {
    const v = String(value || "").trim();
    if (["DayOnly", "BoardingOnly", "Both"].includes(v)) return v;
    if (hasBoardingFallback === true) return "Both";
    return "DayOnly";
}

export function schoolOffersBoarding(boardingMode, hasBoarding) {
    const mode = normalizeBoardingMode(boardingMode, hasBoarding);
    return mode === "BoardingOnly" || mode === "Both";
}

export function boardingModeLabel(boardingMode, hasBoarding) {
    const mode = normalizeBoardingMode(boardingMode, hasBoarding);
    const match = BOARDING_MODES.find((m) => m.value === mode);
    return match?.label || "Day scholar only";
}

export function defaultResidenceType(boardingMode, hasBoarding) {
    const mode = normalizeBoardingMode(boardingMode, hasBoarding);
    return mode === "BoardingOnly" ? "Boarding" : "Day";
}

export function showResidencePicker(boardingMode, hasBoarding) {
    return normalizeBoardingMode(boardingMode, hasBoarding) === "Both";
}

export function requiresHostelAssignment(boardingMode, hasBoarding, residenceType) {
    const mode = normalizeBoardingMode(boardingMode, hasBoarding);
    if (mode === "BoardingOnly") return true;
    return mode === "Both" && residenceType === "Boarding";
}

/** Boarding settings from admin login or nested teacher.school (form teacher enroll). */
export function getSchoolBoardingFromUser(user) {
    const school = user?.school || {};
    const hasBoarding = user?.hasBoarding ?? school?.hasBoarding;
    const boardingMode = normalizeBoardingMode(
        user?.boardingMode ?? school?.boardingMode,
        hasBoarding,
    );
    return { boardingMode, hasBoarding };
}
